export default "__VITE_ASSET__D2Y7ZZbV__"